import {
    AUTOCOMPLETE_FIELD_TYPE,
    DATETIME_TO_DATE_RANGE_FIELD_TYPE,
    INTEGER_RANGE_FIELD_TYPE,
    TEXT_FIELD_TYPE,
    BOOLEAN_FIELD_TYPE
} from "../../../helpers/constants";
import i18n from "../../../i18n";
import DateService from "../../../services/dateService";
import ManageRelatedProductsButton from "../../button/ManageRelatedProductsButton";
import FileTableCell from "../../other/FileTableCell";
import SelectFieldService from "../../../services/selectFieldService";

export const DOCS_TABLE_FILTER_PREFIX = "docs";
export const DOCS_TABLE_NAME = "docs";

export const DOCS_TABLE_CONFIG = [
    {
        name: "investment",
        getValueCallback: (rowData) => rowData.investment_name,
        label: i18n.t("table.docs_table.investment"),
        filterType: AUTOCOMPLETE_FIELD_TYPE,
        getFilterFieldConfigCallback: (filteringData) => ({
            options: filteringData?.value?.investments,
            isObjectOption: true,
            disableClearable: true,
            optionLabelKey: "investment_name_sales",
            style: { minWidth: "150px" }, 
        }),
    },
    {
        name: "manage_products",
        getValueCallback: (rowData) => (
            <ManageRelatedProductsButton
                initialSelectedProductIds={rowData.related_products}
                documentData={rowData}
            />
        ),
        filterType: null,
        getFilterFieldConfigCallback: (filteringData) => undefined,
    },
    {
        name: "docs_nr",
        getValueCallback: (rowData) => rowData.docs_nr,
        label: i18n.t("table.docs_table.docs_nr"),
        filterType: TEXT_FIELD_TYPE,
        getFilterFieldConfigCallback: (filteringData) => undefined,
    },
    {
        name: "docs_name",
        getValueCallback: (rowData) => rowData.docs_name,
        label: i18n.t("table.docs_table.docs_name"),
        filterType: TEXT_FIELD_TYPE,
        getFilterFieldConfigCallback: (filteringData) => undefined,
    },
    {
        name: "docs_parent_nr",
        getValueCallback: (rowData) => rowData.docs_parent_nr,
        label: i18n.t("table.docs_table.docs_parent"),
        filterType: TEXT_FIELD_TYPE,
        getFilterFieldConfigCallback: (filteringData) => undefined,
    },
    {
        name: "docs_revision_nr",
        getValueCallback: (rowData) => rowData.docs_revision_nr,
        label: i18n.t("table.docs_table.docs_revision_nr"),
        filterType: INTEGER_RANGE_FIELD_TYPE,
        getFilterFieldConfigCallback: (filteringData) => undefined,
    },
    // {
    //     name: "docs_investant",
    //     getValueCallback: (rowData) => rowData.docs_investant,
    //     label: i18n.t("table.docs_table.standard"),
    //     filterType: AUTOCOMPLETE_FIELD_TYPE,
    //     getFilterFieldConfigCallback: (filteringData) => ({
    //         options: filteringData?.value?.invest_standard,
    //         isObjectOption: true,
    //         disableClearable: true,
    //         optionLabelKey: "docs_investan_name",
    //         style: { minWidth: "150px" },
    //     }),
    // },
    {
        name: "docs_industry",
        getValueCallback: (rowData) => rowData.docs_industry,
        label: i18n.t("table.docs_table.docs_industry"),
        filterType: AUTOCOMPLETE_FIELD_TYPE,
        getFilterFieldConfigCallback: (filteringData) => ({
            options: filteringData?.value?.industries,
            isObjectOption: true,
            disableClearable: true,
            optionLabelKey: "industry_name",
            style: { minWidth: "150px" },
        }),
    },
    {
        name: "docs_restricted_user",
        label: i18n.t("table.docs_table.docs_restricted_user"),
        getValueCallback: (rowData) => rowData.docs_restricted_user,
        filterType: AUTOCOMPLETE_FIELD_TYPE,
        getFilterFieldConfigCallback: (filteringData) => ({
            options: filteringData.value?.docs_restricted_user,
            isObjectOption: true,
            optionLabelKey: "full_name",
            addNewValue: false,
        }),
    },
    {
        name: "docs_restricted_role",
        label: i18n.t("table.docs_table.docs_restricted_role"),
        getValueCallback: (rowData) => rowData.docs_restricted_role,
        filterType: AUTOCOMPLETE_FIELD_TYPE,
        getFilterFieldConfigCallback: (filteringData) => ({
            options: filteringData.value?.docs_restricted_role,
            isObjectOption: true,
            optionLabelKey: "role_name",
            addNewValue: false,
        }),
    },
    {
        name: "created",
        getValueCallback: (rowData) =>
            DateService.convertDatetimeFromBackendToFormatYYYYMMDD(rowData.created),
        label: i18n.t("table.docs_table.created"),
        filterType: DATETIME_TO_DATE_RANGE_FIELD_TYPE,
        getFilterFieldConfigCallback: (filteringData) => ({
            style: { minWidth: "100px" },
        }),
        sortable: true,
    },
    {
        name: "creator",
        getValueCallback: (rowData) => rowData.creator,
        label: i18n.t("table.docs_table.creator"),
        filterType: AUTOCOMPLETE_FIELD_TYPE,
        getFilterFieldConfigCallback: (filteringData) => ({
            options: filteringData?.value?.creator,
            isObjectOption: true,
            disableClearable: true,
            optionLabelKey: "full_name",
            style: { minWidth: "150px" },
        }),
    },
    // {
    //     name: "docsprod_is_card_pdf",
    //     getValueCallback: (rowData) => SelectFieldService.getLabelOptionsTrueOrFalse(rowData.is_card_pdf),
    //     label: i18n.t("table.docs_table.docsprod_is_card_pdf"),
    //     filterType: BOOLEAN_FIELD_TYPE,
    //     getFilterFieldConfigCallback: (filteringData) => undefined,
    // },
    // {
    //     name: "docsprod_is_card_jpg",
    //     getValueCallback: (rowData) => SelectFieldService.getLabelOptionsTrueOrFalse(rowData.is_card_jpg),
    //     label: i18n.t("table.docs_table.docsprod_is_card_jpg"),
    //     filterType: BOOLEAN_FIELD_TYPE,
    //     getFilterFieldConfigCallback: (filteringData) => undefined,
    // },
    {
        name: "docsinve_is_prospectus",
        getValueCallback: (rowData) => SelectFieldService.getLabelOptionsTrueOrFalse(rowData.is_prospectus),
        label: i18n.t("table.docs_table.docsinve_is_prospectus"),
        filterType: BOOLEAN_FIELD_TYPE,
        getFilterFieldConfigCallback: (filteringData) => undefined,
    },
    {
        name: "note",
        getValueCallback: (rowData) => rowData.note,
        label: i18n.t("table.docs_table.note"),
        filterType: BOOLEAN_FIELD_TYPE,
        getFilterFieldConfigCallback: (filteringData) => undefined,
    },
    {
        name: "buttons",
        getValueCallback: (
            rowData,
            onPreviewDoc,
            onDownloadDoc,
            onDeleteFile,
            readyOnly,
            availableDocsRestrictedTypes,
            fileRefetch,
            showEditButton,
            showRevisionButton,
            index,
            context,
            showRevisionHistoryButton
        ) => {
            return (
                <FileTableCell
                    fileType={"docs"}
                    file={rowData}
                    onPreview={onPreviewDoc}
                    onDownload={onDownloadDoc}
                    onDeleteFile={onDeleteFile}
                    readOnly={typeof readyOnly === "function" ? readyOnly(rowData) : readyOnly}
                    availableDocsRestrictedTypes={availableDocsRestrictedTypes}
                    fileRefetch={fileRefetch}
                    index={index}
                    showDetailsButton={false}
                    showRevisionButton={typeof showRevisionButton === "function" ? showRevisionButton(rowData) : showRevisionButton}
                    showEditButton={typeof showEditButton === "function" ? showEditButton(rowData) : showEditButton}
                    showRevisionHistoryButton={typeof showRevisionHistoryButton === "function" ? showRevisionHistoryButton(rowData) : showRevisionHistoryButton}
                    customer_id={context?.customer_id}
                    agreement_id={context?.agreement_id}
                    isCardJpg={rowData.is_card_jpg}
                    isCardPdf={rowData.is_card_pdf}
                    isProspectus={rowData.is_prospectus}
                    channel_id={context?.channel_id}
                />
            );
        },
        filterType: null,
        getFilterFieldConfigCallback: (filteringData) => ({
            style: { minWidth: "150px" },
        }),
    },
];

export const useDocsTableConfig = () => {
    const getTableProps = ({ excludedFields = [], readOnlyFilters = [] }) => {
        const tableName = DOCS_TABLE_NAME;
        const tablePrefix = DOCS_TABLE_FILTER_PREFIX;
        const tableConfig = DOCS_TABLE_CONFIG.filter(
            (config) => !excludedFields.includes(config.name),
        ).map(config=> !readOnlyFilters.includes(config.name) ? config : {...config, fieldConfig: {readOnly: true}})

        return {
            tableName: tableName,
            tableConfig: tableConfig,
            tableFilterPrefix: tablePrefix,
            configForUserPreferenceDialog: [
                {
                    name: tableName,
                    config: tableConfig,
                },
            ],
        };
    };

    return {
        fetchingFromBackend: false,
        getTableProps: getTableProps,
    };
};
